import classNames from 'classnames';

import Typography from '../../../core/Typography';

import useStyles from './styles';
import IStepWithDescription from './types';

function StepWithDescription({
  className,
  index,
  title,
  description,
  headingElement = 'h1',
}: IStepWithDescription) {
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.indicator}>{index}</div>
      <div className={classes.text}>
        <Typography className={classes.title} element={headingElement} look="h5">
          {title}
        </Typography>
        <Typography
          className={classes.description}
          element="p"
          look="body"
          color="var(--x-text-color-2)"
        >
          {description}
        </Typography>
      </div>
    </div>
  );
}

export default StepWithDescription;
